module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/contact-address-icon.26b44770.svg";